import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    .p-datatable-wrapper {
        max-width: ${document.body.clientWidth-426}px;
        min-width: 100%;
        overflow: auto;
        min-height:500px;
    }
`;

export default GlobalStyle;
